﻿import { LiveDataSet, Status } from "../../API/LiveData/LiveDataSet";
import { ParameterSchemaSensor } from "../../API/Schema/ParameterSchema";
import { DefaultGroupFormatter } from "../../Formatters/DefaultGroupFormatter";
import { IStationValueFormatter, IStationValueObject } from "../../Formatters/IStationValueFormatter";
import { ILiveDataListener } from "../../ILiveDataListener";
import { MainSite } from "../../MainSite";
import { CompassSector } from "../../Model/CompassSector";
import { ParameterGroupInfo, ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { ISiteObservationsPage } from "./ISiteObservationsPage";

export class WindCompass implements ILiveDataListener {

    private page: ISiteObservationsPage;

    private valueBox: JQuery;
    private stationId: string;

    private container: JQuery;
    private canvas: JQuery;
    private canvasLabelsWrap: JQuery;
    private windCompassPaper: RaphaelPaper;
    private movingParts: RaphaelSet;
    private platformBitmap: RaphaelElement;
    private platformBitmapOverLayer: RaphaelElement;

    private width: number;
    private height: number;
    private radius: number;

    private sensorId: string;
    private compassLog: string[] = [];
    private appliedCompassSectors: CompassSector[] = [];

    public windSpeedGroup: ParameterGroupInfo = ParameterGroupInfoSet.WindSpeed_kts;
    public gustSpeedGroup: ParameterGroupInfo = ParameterGroupInfoSet.GustSpeed_kts;
    public windSpeedGroup1min: ParameterGroupInfo = ParameterGroupInfoSet.WindSpeed_kts_1min;
    public gustSpeedGroup1min: ParameterGroupInfo = ParameterGroupInfoSet.GustSpeed_kts_1min;
    public windSpeedGroup10min: ParameterGroupInfo = ParameterGroupInfoSet.WindSpeed_kts_10min;
    public gustSpeedGroup10min: ParameterGroupInfo = ParameterGroupInfoSet.GustSpeed_kts_10min;

    constructor(page: ISiteObservationsPage, container: JQuery, top: number, left: number, height: number, width: number, sensorId: string = null, private is10m: boolean = false) {
        this.stationId = page.station.Station.Id;
        this.page = page;
        this.container = container;
        this.sensorId = sensorId;

        if (this.is10m == true) {
            this.windSpeedGroup = ParameterGroupInfoSet.WindSpeed_kts_10m;
            this.gustSpeedGroup = ParameterGroupInfoSet.GustSpeed_kts_10m;
            this.windSpeedGroup1min = ParameterGroupInfoSet.WindSpeed_kts_10m_1min;
            this.gustSpeedGroup1min = ParameterGroupInfoSet.GustSpeed_kts_10m_1min;
            this.windSpeedGroup10min = ParameterGroupInfoSet.WindSpeed_kts_10m_10min;
            this.gustSpeedGroup10min = ParameterGroupInfoSet.GustSpeed_kts_10m_10min;
        }

        this.canvas = $('<div class="midi_SiteObservations_wind_compass_container"></div>').appendTo(this.container)
            .css('position', 'absolute')
            .css('top', top + '%')
            .css('left', left + '%')
            .css('height', height + '%')
            .css('width', width + '%');             
        this.windCompassPaper = Raphael($('<div class="midi_SiteObservations_wind_compass"></div>').appendTo(this.canvas)[0],
            50, 50);//arbitrary width and height just so it draws one first time. this will always be redrawn before we see it.

        this.canvasLabelsWrap = $('<div>').addClass("windcompass-sector-labels").prependTo(this.canvas);

        this.movingParts = this.windCompassPaper.set();

        // console.info("[WindCompass]", { _this: this, cont: container });
    }

    public liveDataChanged(latestData: LiveDataSet): void {
        this.redrawMovingParts(latestData);
        this.updateImageBitmapRotation(latestData);
        // console.info("[WindCompass] - liveDataChanged()...", { compassLog: this.compassLog });
    }

    private drawCompassSectors(finalSensorId: string, origin: string): void {
        this.compassLog = ["[WindCompass][sectors] - started (origin: " + origin + ", finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ")."];

        let sectors: CompassSector[] = MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].CompassSectors;

        if (sectors.length > 0) {
            this.canvasLabelsWrap.empty();
            this.appliedCompassSectors = [];
            this.compassLog.push("[WindCompass][sectors] - emptying labels wrap.");

            sectors.forEach((sector) => {
                if (this.appliedCompassSectors.filter(x => x.Id === sector.Id).length > 0) {
                    this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - Loop ignored as we've already applied a compass sector with this GUID.");
                    return;
                }
                if (this.appliedCompassSectors.filter(x => x.StationId == sector.StationId && x.FromDegrees == sector.FromDegrees && x.ToDegrees == sector.ToDegrees && x.Label == sector.Label && x.Colour == sector.Colour).length > 0) {
                    this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - Loop ignored as we've already applied a compass sector with this matching parameters (except SensorId).");
                    return;
                }

                this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - Loop started (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ").");

                //: does the sector apply here or not?
                let applySector: boolean = false;

                //: ORIGINAL labels condition:
                // (sector.SensorId !== null && sector.SensorId !== finalSensorId) || sector.Label == null
                //: ORIGINAL sector condition:
                // sector.SensorId !== null && sector.SensorId !== finalSensorId

                if (applySector === false && this.sensorId !== null && this.sensorId === sector.SensorId) {
                    applySector = true;
                    this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - apply as (this<WindCompass>.sensorId === sector.SensorId).  (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ")");
                }

                if (applySector === false && finalSensorId !== null && finalSensorId === sector.SensorId) {
                    applySector = true;
                    this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - apply as (finalSensorId === sector.SensorId).  (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ")");
                }

                if (applySector === false && sector.SensorId === null) { //: default: sector.SensorId === null, so apply (matches previous behaviour, and allows to add Flight Restriction warnings on all compasses.)
                    if (this.appliedCompassSectors.filter(x => x.StationId == sector.StationId && x.FromDegrees == sector.FromDegrees && x.ToDegrees == sector.ToDegrees).length > 0) {
                        this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - APPLY IGNORED AS WE'VE ALREADY GOT THIS SECOTR (sector.SensorId is null - default apply to all sensors).  (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ")");
                    } else {
                        applySector = true;
                        this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - apply as (sector.SensorId is null - default apply to all sensors).  (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ")");
                    }
                }

                //: check if this is a combined sensor:
                if (!applySector) {
                    try {
                        var sensor: ParameterSchemaSensor = MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors[finalSensorId];
                        if (sensor && sensor.SensorDefinition && sensor.SensorDefinition.Combined) {
                            applySector = true;
                            this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - apply as (finalSensorId detected as a 'Combined Wind Sensor').  (finalSensorId = " + finalSensorId + ", compassSensor = " + this.sensorId + ", sectorSensor = " + sector.SensorId + ")");
                        }
                    } catch (e) {
                        console.warn("Error while checking WindCompass for Combined Wind Sensor: ", e);
                    }
                }

                if (applySector === false) {
                    this.compassLog.push("[WindCompass][sector][" + sector.Id + "/" + sector.SensorId + "] - DO NOT APPLY." + ` [sectorSensor: ${sector.SensorId}, finalSensorId: ${finalSensorId}, compassSensor: ${this.sensorId}]`);
                }

                if (applySector === true) {
                    this.appliedCompassSectors.push(sector);

                    //: add labels:
                    if (sector.Label !== null && sector.Label.length > 0) {
                        let $lbl = $('<div>').addClass('windcompass-sector-label').attr("data-guid", sector.Id).html('' + sector.Label).css("fontSize", ".6em").appendTo(this.canvasLabelsWrap);
                        let $lblColour = $('<span>').addClass('windcompass-sector-label-colour').css({
                            "display": "inline-block",
                            "borderRadius": "100%",
                            "width": "8px",
                            "height": "8px",
                            "marginRight": "3px",
                            "backgroundColor": sector.Colour
                        }).prependTo($lbl);
                    }

                    //: add sectors to compass:
                    if (applySector) { //: otherwise it means we don't have other compass elements yet..
                        //starting position (i.e. middle of compass canvas)
                        var startX = this.width / 2;
                        var startY = this.height / 2;
                        var sectorRadius = this.radius / 1.4;

                        //: rx ry x-axis-rotation large-arc-flag sweep-flag x y
                        var diff = sector.FromDegrees > sector.ToDegrees ? 360 - sector.FromDegrees + sector.ToDegrees : sector.ToDegrees - sector.FromDegrees;
                        var largeArcFlag = diff > 180 ? 1 : 0;

                        var sectorPie: RaphaelElement = this.windCompassPaper.path(
                            'M' + this.polarToCartesian(startX, startY, 0, 0) +
                            'L' + this.polarToCartesian(startX, startY, sectorRadius, sector.FromDegrees) +
                            'A' + (sectorRadius) + ',' + (sectorRadius) + ',' + 0 + ',' + largeArcFlag + ',' + 1 + ',' + this.polarToCartesian(startX, startY, sectorRadius, sector.ToDegrees) + // + ',' + startY +
                            'Z'
                        ).attr({
                            'stroke': 'transparent',
                            'fill': sector.Colour
                        });

                        this.movingParts.push(sectorPie);
                    }
                }
            });
        }

        this.compassLog.push("[WindCompass][sectors] - finished.");
        // console.info("[WindCompass][drawCompassSectors()]", this.compassLog, this);
    }

    public drawCompass(): void {
        this.width = this.canvas.width();
        this.height = this.canvas.height();

        this.drawCompassSectors(this.sensorId, "drawCompass");

        var sectorLabelsHeight: number = 0;
        sectorLabelsHeight = this.canvasLabelsWrap.outerHeight();
        if (sectorLabelsHeight > 0) {
            sectorLabelsHeight += 5;
            this.height = this.height - sectorLabelsHeight;
            this.compassLog.push("[WindCompass][sectors] - adjusted compass height (this.height = " + this.height + ").");
        }

        this.windCompassPaper.clear();
        this.windCompassPaper.setSize(this.width, this.height);

        //sizes of wind compass components
        this.radius = Math.min(this.width, this.height) / 2;

        //draw directional labels
        var textPadding = (this.width / 100) * 2.5;

        //draw platform image background
        const imgWidth = Math.min(this.width, this.height);

        this.platformBitmap = this.windCompassPaper.image(location.protocol + "//" + location.host + "/api/PlatformBitmaps/" + this.stationId,
            imgWidth === this.width ? 0 : this.width / 2 - this.height / 2,
            imgWidth === this.width ? this.height / 2 - this.width / 2 : 0,
            imgWidth === this.width ? this.width : this.height,
            imgWidth === this.width ? this.width : this.height);

        this.platformBitmapOverLayer = this.windCompassPaper.rect(imgWidth === this.width ? 0 : this.width / 2 - this.height / 2,
            imgWidth === this.width ? this.height / 2 - this.width / 2 : 0,
            imgWidth === this.width ? this.width : this.height,
            imgWidth === this.width ? this.width : this.height).attr({
                'fill': 'white',
                'opacity': 0.5,
                'stroke-width': 0,
            });
        

        this.generateCompassText(this.width / 2, this.height / 2 - this.radius + textPadding, "N",5);
        this.generateCompassText(this.width / 2, this.height / 2 + this.radius - textPadding, "S",5);
        this.generateCompassText(this.width / 2 + this.radius - textPadding, this.height / 2, "E",5);
        this.generateCompassText(this.width / 2 - this.radius + textPadding, this.height / 2, "W",5);          

        if (this.page.mainSite.liveDataManager.latestData) {
            this.redrawMovingParts(this.page.mainSite.liveDataManager.latestData);
            this.updateImageBitmapRotation(this.page.mainSite.liveDataManager.latestData);
        }
    }

    private updateImageBitmapRotation(latestData: LiveDataSet) {
        const valueF = new DefaultGroupFormatter(ParameterGroupInfoSet.Heading_deg);
        let headingDeg = valueF.format(latestData.Stations[this.stationId]).Value
        if (this.platformBitmap && !isNaN(parseFloat(headingDeg))) {
            this.platformBitmap.transform('r' + valueF);
            this.platformBitmapOverLayer.transform('r' + valueF);
        }
    }

    private redrawMovingParts(latestData: LiveDataSet): void {
        this.movingParts.remove();
        this.movingParts = this.windCompassPaper.set();

        //values and formatters for parameters which are to be displayed on the wind compass
        var dirValFormatter: IStationValueFormatter = new DefaultGroupFormatter(ParameterGroupInfoSet.WindDirection_deg, this.sensorId);
        var dirObject: IStationValueObject = dirValFormatter.format(latestData.Stations[this.stationId]);

        var speedValFormatter: IStationValueFormatter = new DefaultGroupFormatter(this.windSpeedGroup, this.sensorId);
        var speedObject: IStationValueObject = speedValFormatter.format(latestData.Stations[this.stationId]);


        var dirBackedValFormatter: IStationValueFormatter = new DefaultGroupFormatter(ParameterGroupInfoSet.WindDirection_Backed_deg, this.sensorId);
        var backedObject: IStationValueObject = dirBackedValFormatter.format(latestData.Stations[this.stationId]);

        var dirVeeredValFormatter: IStationValueFormatter = new DefaultGroupFormatter(ParameterGroupInfoSet.WindDirection_Veered_deg, this.sensorId);
        var veeredObject: IStationValueObject = dirVeeredValFormatter.format(latestData.Stations[this.stationId]);


        //sizings
        var outerPadding = 0.2 * this.radius;
        var ringWidth = 0.1 * this.radius;
        var arrowSize = 0.24 * this.radius;
        var labelXPadding = 0.08 * this.radius;
        var labelHeight = 0.24 * this.radius;
        var labelFont = 'bold ' + (0.16 * this.radius) + 'px verdana';

        //starting position (i.e. middle of compass canvas)
        var startX = this.width / 2;
        var startY = this.height / 2;

        // draw the sensor text
        var levelString = "";
        var sensorString = "";
        var sensorId = null;

        if (this.sensorId) {
            // sensorId set in constructor
            sensorId = this.sensorId;
        }
        else if (ParameterGroupInfoSet.WindSelectedSensorId.Id in latestData.Stations[this.stationId].GroupValues) {
            // we can infer that it is a multiple sensor site
            let sourceIndex = latestData.Stations[this.stationId].GroupValues[ParameterGroupInfoSet.WindSelectedSensorId.Id][0].Value;

            //: lookup site sensors for matching SensorDefinition.SourceIndex, to use appropropriate sensor & definitions:
            for (let _matchingIndexSensorId in MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors) {
                let _sensor: ParameterSchemaSensor = MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors[_matchingIndexSensorId];
                if (_sensor.SensorDefinition && _sensor.SensorDefinition.SourceIndex) {
                    if (_sensor.SensorDefinition.SourceIndex == (sourceIndex).toString()) { //: NB: loosely typed checking! we're converting the potential sourceIndex from SelectedSensorId to string, as the SourceIndex in definitions will always be a string.
                        sensorId = _matchingIndexSensorId;
                    }
                }
            }
        }
        else if (latestData.Stations[this.stationId].GroupValues[ParameterGroupInfoSet.WindDirection_deg.Id]) {
            // it is a single sensor site
            sensorId = latestData.Stations[this.stationId].GroupValues[ParameterGroupInfoSet.WindDirection_deg.Id][0].Sensor;
        } else {
            return;
        }

        var sensor = MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors[sensorId];

        // add possible CompassSectors for this station/params:
        this.drawCompassSectors(sensorId, "redrawMovingParts()");

        if (sensor && sensor.SensorDefinition && sensor.SensorDefinition.DisplayName) {
            sensorString = sensor.SensorDefinition.DisplayName;
        } else {
            sensorString = sensorId;
        }

        if (sensor && sensor.SensorDefinition && sensor.SensorDefinition.Level && !this.is10m) {
            levelString = "@ " + sensor.SensorDefinition.Level;
        }

        var levelText = this.generateCompassText(startX, startY + this.height / 12, levelString, 5);
        this.movingParts.push(levelText); 

        var sensorText = this.generateCompassText(startX, startY - this.height / 12, sensorString, 5);
        this.movingParts.push(sensorText); 

        //compassArcs
        if (backedObject.Status !== null && backedObject.Status !== Status.Expired && veeredObject.Status !== null && veeredObject.Status !== Status.Expired) {
            var difference = parseFloat(veeredObject.Value) - parseFloat(backedObject.Value);
            if (difference < 0) {
                difference += 360;
            }

            //tells us whether we are dealing with a large-arc (svg arcs)
            var arcFlag = 0;

            if (difference <= 180) {
                arcFlag = 1;
            }

            var mainCompassArc: RaphaelElement = this.windCompassPaper.path(
                'M' + this.polarToCartesian(startX, startY, this.radius / 1.3, parseFloat(backedObject.Value)) +
                'A' + (this.radius / 1.3) + ',' + (this.radius / 1.3) + ',' + 0 + ',' + arcFlag + ',' + 0 + ',' + this.polarToCartesian(startX, startY, this.radius / 1.3, parseFloat(veeredObject.Value)) + ',' + startY
                ).attr({
                    'stroke-width': ringWidth,
                    'stroke': '#8d8d8d'
            });
            var variabilityCompassArc:RaphaelElement = this.windCompassPaper.path(
                'M' + this.polarToCartesian(startX, startY, this.radius / 1.3, parseFloat(backedObject.Value)) +
                'A' + (this.radius / 1.3) + ',' + (this.radius / 1.3) + ',' + 0 + ',' + (1 - arcFlag) + ',' + 1 + ',' + this.polarToCartesian(startX, startY, this.radius / 1.3, parseFloat(veeredObject.Value)) + ',' + startY
                ).attr({
                    'stroke-width': ringWidth,
                    'stroke': '#fbce07' //shell-yellow
                });

            this.movingParts.push(mainCompassArc);
            this.movingParts.push(variabilityCompassArc);

        }
        else {
            var circle: RaphaelElement = this.windCompassPaper.circle(startX, startY, this.radius/1.3).attr({
                'stroke-width': ringWidth,
                'stroke': '#8d8d8d'
            });

            this.movingParts.push(circle);
        }

        //compass markers
        for (var i: number = 0; i < 360; i += 10) {
            var compassMarker: RaphaelElement = this.windCompassPaper.path(
                'M' + this.polarToCartesian(startX, startY, this.radius / 1.2, i) +
                'L' + this.polarToCartesian(startX, startY, this.radius / 1.4, i)
                ).attr({
                    'stroke': '#ffffff',
                    'stroke-width': 2
                });

            this.movingParts.push(compassMarker); // need to be redrawn to go on top of ring?
        }

        //wind dir
        if (dirObject.Status !== null && dirObject.Status !== Status.Expired) {
            var direction = parseFloat(dirObject.Value);
            var arrow: RaphaelElement = this.windCompassPaper.path(
                'M' + this.polarToCartesian(startX, startY, this.radius / 1.9, direction) +
                'L' + this.polarToCartesian(startX, startY, this.radius / 1.45, direction - 10) +
                //'L' + this.polarToCartesian(startX, startY, this.radius / 1.45, direction + 10) +
                'A' + (this.radius / 1.45) + ',' + (this.radius / 1.45) + ',' + 20 + ',' + 0 + ',' + 1 + ',' + this.polarToCartesian(startX, startY, this.radius / 1.45, direction + 10) + ',' + startY +
                'Z'
                ).attr({
                    'stroke': '#33CC33',
                    'fill': '#33CC33'
                });

            this.movingParts.push(arrow); 
        }

        var dirSpeedString = "";
                                
        if (dirObject.Status !== null && dirObject.Status !== Status.Expired) {
            dirSpeedString += dirObject.Value + " °T";

            if (speedObject.Status !== null && speedObject.Status !== Status.Expired) {
                //cope with multiple spaces between dir and speed
                dirSpeedString += "\u00a0\u00a0";
            }
        }

        if (speedObject.Status !== null && speedObject.Status !== Status.Expired) {
            dirSpeedString += speedObject.Value + ' ' + MainSite.getUnitConverter().getConvertedUnits(this.windSpeedGroup.Units, this.windSpeedGroup.Id);
        }
        var dirSpeedText = this.generateCompassText(startX, startY, dirSpeedString, 6);     

        this.movingParts.push(dirSpeedText); 
    }

    private generateCompassText(x: number, y: number, text: string, size: number = 7, bold: boolean = true) {
        var compassFontFamily = "Helvetica";
        var compassFontWeight = bold ? "bold" : "normal";
        var compassFontSize = (this.width / 100) * size;

        var textElement = this.windCompassPaper.text(x, y, text).attr({
            "font-family": compassFontFamily,
            "font-weight": compassFontWeight,
            "font-size": compassFontSize,
            "fill": '#4d4d4d'
        });
        return textElement;
    }

    private polarToCartesian(centerX:number, centerY:number, radius:number, angleInDegrees:number):string {
        var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
        var x = centerX + (radius * Math.cos(angleInRadians));
        var y = centerY + (radius * Math.sin(angleInRadians));

        var xyString = x + "," + y;
    
        return xyString;
    }

}